/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_ExistsInputs */

const cs_op_exists = /** @type {(inputs: Op_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`existuje`)
};

const en_op_exists = /** @type {(inputs: Op_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`exists`)
};

/**
* | output |
* | --- |
* | "exists" |
*
* @param {Op_ExistsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_exists = /** @type {((inputs?: Op_ExistsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_ExistsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_exists(inputs)
	return cs_op_exists(inputs)
});